import createProperty from './create-property';

export default createProperty({
  default: false,
  validate(v) {
    return typeof v === 'boolean';
  },
});
